import React, { useRef } from 'react'
import { useCopy } from '../clipboard/clipboard'

// A value to copy: a read-only field and Copy beside it. Copy goes through
// the shared helper (shared/clipboard/clipboard.js), which writes inside the
// click -- what Safari requires -- and says "Copied" only after a real copy;
// otherwise the value is selected and the shortcut is named.
//
// Open (owner 2026-10-07): a copyable URL can also be opened, for when the
// person who copies it is the one who uses it. `openHref` is a link in a new
// tab (rel="noopener" unless `openRel` says otherwise -- a signed-in admin
// page needs "opener", its session lives in sessionStorage); `onOpen` is a
// button for anything else.
//
// size="sm": the compact field an error's reference uses (error-reference.js).
export const CopyValue = ({ id, label, value, hint, size, openHref, openRel = 'noopener', onOpen, openLabel = 'Open' }) => {
  const copy = useCopy()
  const input = useRef(null)

  return (
    <div className="sw-copy sw-field">
      <label className="sw-label" htmlFor={id}>{label}</label>
      <div className={size === 'sm' ? 'input-group input-group-sm' : 'input-group'}>
        <input id={id} ref={input} className="form-control sw-mono" value={value} readOnly onFocus={e => e.target.select()} />
        <button type="button" className="btn sw-btn" aria-label={`copy ${label}`} onClick={() => copy.copy(value, input)}>{copy.copied ? 'Copied' : 'Copy'}</button>
        {openHref &&
          // eslint-disable-next-line react/jsx-no-target-blank -- rel is the caller's choice (see above)
          <a className="btn sw-btn" href={openHref} target="_blank" rel={openRel} aria-label={`${openLabel} ${label}`}>{openLabel}</a>}
        {!openHref && onOpen &&
          <button type="button" className="btn sw-btn" aria-label={`${openLabel} ${label}`} onClick={onOpen}>{openLabel}</button>}
      </div>
      {copy.manual && <div className="sw-hint sw-copy-manual" role="status">{copy.hint}</div>}
      {hint && <div className="sw-hint">{hint}</div>}
    </div>
  )
}
